export * as BaseTooltipPlugin from './BaseTooltip';
/** @deprecated */
export * as TooltipButtonPlugin from './TooltipButton';
/** @deprecated */
export * as TooltipSelectPlugin from './TooltipSelect';
